<template>
    <div class="home font-family-1">
        <v-app-bar
                app
                color="#FFF"
                height="120px"
        >
                <v-img
                            alt="Neocity Logo"
                            class="d-none d-sm-flex"
                            contain
                            src="@/assets/images/neocity-logo.png"
                            transition="scale-transition"
                            height="60"
                    />
                    <v-img
                            alt="Neocity Favicon"
                            class="d-sm-none"
                            contain
                            src="@/assets/images/favicon.png"
                            transition="scale-transition"
                            height="60"
                    />
               <span class="title-nav font-family-1 d-none d-lg-flex">Sistema de Administración de planes de Energía</span>

            <v-spacer></v-spacer>
            <a href="#" class="mr-5 btn-nav-text-1 font-family-2" @click.stop="dialog.login.show = true" > Iniciar Sesión</a>
            <v-btn tile color="primary btn-nav-text-1 btn-nav-blue-1 font-family-2 mr-5" @click.stop="dialog.register.show = true" > Registrarse</v-btn>
        </v-app-bar>

        <v-carousel
                class="carousel-home"
                height="auto"
                hide-delimiter-background
                show-arrows-on-hover
        >
            <v-carousel-item
                    v-for="(item,i) in carousel.items"
                    :key="i"
                    :src="item.src"
            >
                <v-container fill-height fluid>
                    <v-row
                            align="center"
                            justify="center"
                    >
                        <v-col class="text-center mx-auto" cols="12">
                            <h3 class="white--text font-size-40 font-weight-black mb-4 font-family-1">{{ item.title }}</h3>
                            <h3 class="white--text font-size-20 subheading font-weight-medium font-family-1 ">{{ item.subtitle }}</h3>
                            <v-btn class="ma-2 mt-6 blue--text" tile large color="white">
                                {{ item.btn.text }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-carousel-item>
        </v-carousel>

        <v-container>
            <v-layout>
                <v-flex class="text-center my-12">
                    <h2 class="font-weight-black text--secondary font-family-1">CONOCE NUESTROS PLANES</h2>
                    <p class="subtitle-2 blue--text font-family-1">Selecciona el perfil que más te acomode</p>
                    <v-card
                            class="mx-auto pa-12"
                            tile
                            style="background: #FFF"
                    >
                        <v-row>
                            <v-col md="" cols="12">
                                <v-img
                                        contain
                                        class="mb-4"
                                        height="60"
                                        src="@/assets/images/icono-consumidor.png"
                                ></v-img>
                                <h3 class="mb-4 font-weight-medium">Consumidor</h3>
                                <p class="pl-3 pr-3 mb-4 caption">Empresas compradoras de suministro eléctrico</p>
                                <a href="#" class="text-decoration-none caption font-weight-bold"> Registrarme</a>
                            </v-col>
                            <v-col md="" cols="12">
                                <v-img
                                        contain
                                        class="mb-4"
                                        height="60"
                                        src="@/assets/images/icono-generador.png"
                                ></v-img>
                                <h3 class="mb-4 font-weight-medium">Generador</h3>
                                <p class="pl-3 pr-3 mb-4 caption">Productores y vendedores de energia eléctrica</p>
                                <a href="#" class="text-decoration-none caption font-weight-bold"> Registrarme</a>
                            </v-col>
                            <v-col md="" cols="12">
                                <v-img
                                        contain
                                        class="mb-4"
                                        height="60"
                                        src="@/assets/images/icono-reportes.png"
                                ></v-img>
                                <h3 class="mb-4 font-weight-medium">Reportes</h3>
                                <p class="pl-3 pr-3 mb-4 caption">Información útil y análisis del mercado eléctrico para
                                    ejecutivos</p>
                                <a href="#" class="text-decoration-none caption font-weight-bold"> Registrarme</a>
                            </v-col>
                            <v-col md="" cols="12">
                                <v-img
                                        contain
                                        class="mb-4"
                                        height="60"
                                        src="@/assets/images/icono-proveedores.png"
                                ></v-img>
                                <h3 class="mb-4 font-weight-medium">Proveedores</h3>
                                <p class="pl-3 pr-3 mb-4 caption">Empresas de apoyo a la gestion de producción para consumidores
                                    o generadores</p>
                                <a href="#" class="text-decoration-none caption font-weight-bold"> Registrarme</a>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-parallax
                height="300"
                src="@/assets/images/ciudad-grises.png"
        >
            <v-containr fill-height fluid>
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col class="text-center my-auto" cols="9">
                        <h1 class="font-size-40 font-family-1 font-weight-bold mb-4">SIMPLIFICAMOS LOS CONTRATOS Y TRANSPARENTAMOS
                            LAS CONDICIONES</h1>
                        <h3 class="font-weight-regular font-size-20 font-family-1 subheading">Toma mejores decisiones con toda la información disponible</h3>
                    </v-col>
                </v-row>
            </v-containr>
        </v-parallax>

        <v-footer padless>
            <v-container>
                <v-row>
                    <v-col md="4" cols="12">
                        <h5 class="mb-5">Neocity</h5>
                        <p class="caption">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sit amet aliquet ipsum. Lorem
                            ipsum dolor sit amet, consectetur adipiscing elit. Fusce sit amet aliquet ipsum.
                        </p>
                    </v-col>
                    <v-col md="4" cols="12">
                        <h5 class="mb-5">Acerca de Neocity</h5>
                        <v-list  color="transparent">
                            <v-list-item class="pl-3" dense>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <a class="text-decoration-none caption" href="#">Qué hacemos</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item class="pl-3" dense>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <a class="text-decoration-none caption" href="#">Cómo lo hacemos</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item class="pl-3" dense>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <a class="text-decoration-none caption" href="#">Cómo cobramos</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item class="pl-3" dense>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <a class="text-decoration-none caption" href="#">Misión y Visión</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>

                    </v-col>
                    <v-col md="4" cols="12">
                        <h5 class="mb-5">Solicita el contacto de un ejecutivo</h5>
                        <v-text-field
                                label="Ingresa tu Nombre"
                                solo
                                dense
                                caption
                                hide-details
                                class="mb-2"
                        ></v-text-field>
                        <v-text-field
                                label="Ingresa tu Email"
                                solo
                                dense
                                caption
                                hide-details
                                class="mb-3"
                        ></v-text-field>
                        <v-btn tile color="primary caption float-right">Enviar</v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="caption font-italic grey--text">
                    <v-col md="6" cols="12">
                        <strong>Neocity {{ new Date().getFullYear() }}</strong> - Todos los derechos reservados. Version
                        1.3
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col md="6" cols="12" class="text-right">
                        Diseñado por <a class="text-decoration-none" href="#">Hive.cl</a>
                    </v-col>
                </v-row>


            </v-container>
        </v-footer>

        <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
        <!--        Inicar session-->
        <v-dialog
                v-model="dialog.login.show"
                width="480"
                class="text-center"
        >
            <v-card class="homeDialog pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    iniciar sesión
                </v-card-title>
                <p class="caption color-light-grey text-center mt-4"><a href="#" class="text-underline">Registrate</a> o Inicia sesión con tus datos</p>

                <v-card-text>

                    <v-text-field
                            label="Email"
                            single-line
                            outlined
                            type="email"
                            prepend-inner-icon="mdi-email"
                    ></v-text-field>

                    <v-text-field
                            label="Password"
                            single-line
                            outlined
                            type="password"
                            prepend-inner-icon="mdi-lock"
                    ></v-text-field>

                    <v-select
                            :items="items"
                            label="Selecciona tu perfil de usuario"
                            outlined
                            prepend-inner-icon="mdi-account"
                    ></v-select>

                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            class="px-6"
                            to="/system/generator/dashboard"
                            @click="dialog.login.show = false"
                    >
                        Ingresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="dialog.login.show = false"
                    >
                        ¿Olvidaste tu contraseña?
                    </v-btn>
                </v-card-actions>
                <v-card-actions class="justify-center mx-3">
                    <h5 class="caption color-light-grey">Tienes alguna duda? <a href="#" >Escribenos</a> o llámanos al <a href="#" class="text-underline">+569 2235 5665</a></h5>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--    Registrar    -->
        <v-dialog
                v-model="dialog.register.show"
                width="60%"
                min-width="320px"
                class="text-center"
        >
            <v-card class="homeDialog pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    REGÍSTRATE
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <p class="caption text-center">Registrate acá, te enviaremos un correo con tus datos</p>
                            <v-text-field
                                    label="Email"
                                    single-line
                                    outlined
                                    type="email"
                                    prepend-inner-icon="mdi-email"
                            ></v-text-field>

                            <v-text-field
                                    label="Password"
                                    single-line
                                    outlined
                                    type="password"
                                    prepend-inner-icon="mdi-lock"
                            ></v-text-field>

                            <v-select
                                    :items="items"
                                    label="Selecciona tu perfil de usuario"
                                    outlined
                                    prepend-inner-icon="mdi-account"
                            ></v-select>
                            <v-btn
                                    color="primary"
                                    raised
                                    dark
                                    class="mt-4 px-6"
                                    to="/system/generator/dashboard"
                                    @click="dialog.login.show = false"
                            >
                                Ingresar
                            </v-btn>
                            <v-btn
                            class="mt-4"
                                    color="primary"
                                    text
                                    @click="dialog.login.show = false"
                            >
                                ¿Olvidaste tu contraseña?
                            </v-btn>
                        </v-col>
                        <v-col class="justify-center">
                            <p class="caption text-center">También puedes iniciar sesión con tus redes sociales</p>
                            <v-btn tile class="my-5 py-5" block color="primary" x-large dark>
                                <v-icon class="pl-6" left>mdi-facebook</v-icon>
                                <v-divider class="pl-6" vertical></v-divider>
                                <v-spacer></v-spacer>
                                <span class="text-lowercase" >Inicia con <b class="text-capitalize"> Facebook</b></span>
                            </v-btn>
                            <v-btn tile class="my-5 py-5" block color="blue" x-large dark>
                                <v-icon class="pl-6" left>mdi-twitter</v-icon>
                                <v-divider class="pl-6" vertical></v-divider>
                                <v-spacer></v-spacer>
                                <span class="text-lowercase" >Inicia con <b class="text-capitalize">Twitter</b></span>
                            </v-btn>
                            <v-btn tile class="my-5 py-5" block color="primary" x-large dark>
                                <v-icon class="pl-6" left>mdi-linkedin</v-icon>
                                <v-divider class="pl-6" vertical></v-divider>
                                <v-spacer></v-spacer>
                                <span class="text-lowercase" >Inicia con <b class="text-capitalize">Linkedin</b></span>
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions class="justify-center">
                    <h5 class="caption color-light-grey ">Tienes alguna duda? <a href="#" >Escribenos</a> o llámanos al <a href="#" class="text-underline">+569 2235 5665</a></h5>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

    export default {
        name: 'Home',
        metaInfo: {
            title: 'Neocity - Mejor Energía',
            meta: [
                { name: 'title',content:'Neocity - Mejor Energía'},
                { name: 'description',content:'Neocity, Mejor Energía'},
            ]
        },
        data() {
            return {
                dialog: {
                    register:{
                        show: false
                    },
                    login:{
                        show: false
                    }
                },
                items: ['Consumidor', 'Generador', 'Reportes', 'Proveedores'],
                carousel: {
                    items: [
                        {
                            title: 'CONTRATA ENERGÍA EN POCOS CLICS',
                            subtitle: 'Fácil, Rápido e Informado',
                            btn: {
                                text: 'Explora Nuestras Ofertas',
                                href: '#',
                            },
                            src: require('@/assets/images/ciudad-slider.png'),
                        },
                        {
                            title: 'CONTRATA ENERGÍA EN POCOS CLICS',
                            subtitle: 'Fácil, Rápido e Informado',
                            btn: {
                                text: 'Explora Nuestras Ofertas',
                                href: '#',
                            },
                            src: require('@/assets/images/ciudad-slider.png'),
                        },
                        {
                            title: 'CONTRATA ENERGÍA EN POCOS CLICS',
                            subtitle: 'Fácil, Rápido e Informado',
                            btn: {
                                text: 'Explora Nuestras Ofertas',
                                href: '#',
                            },
                            src: require('@/assets/images/ciudad-slider.png'),
                        },
                    ],

                }
            }
        },
    }
</script>
<style lang="scss">



    .carousel-home{
        height: 450px !important;
        @media (min-width: 768px) {
            height: 665px !important;

        } 

        .v-image{
             height: 450px !important;
            @media (min-width: 768px) {
                height: 665px !important;

            } 
        }
    }

        .v-dialog .homeDialog{
            .v-input__control{
                height:62px !important;
                .v-text-field__slot{
                    padding-bottom:0px !important;
                } 
                .v-input__slot{
                    margin-bottom: 0 !important;
                }
            }
           
        }
           
    
    .v-input input {
        font-size: .7em;
    }
    .v-input .v-label {
        font-size: .7em;
    }
    .text-decoration-none{
        text-decoration: none !important;
    }
    .border-0{
        border: none !important;
    }
    body, .home {
        background: #F3F5F9 !important;
    }
</style>
